module.exports = require('./dist/lib/al-ex/client-export')
